import { render, staticRenderFns } from "./franchiseApplicationProtocol.vue?vue&type=template&id=5bff2ac9&scoped=true"
import script from "./franchiseApplicationProtocol.vue?vue&type=script&lang=js"
export * from "./franchiseApplicationProtocol.vue?vue&type=script&lang=js"
import style0 from "./franchiseApplicationProtocol.vue?vue&type=style&index=0&id=5bff2ac9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff2ac9",
  null
  
)

export default component.exports